/**
 * @packageDocumentation
 * @module dom/element
 */

export interface ExistsIn {
  /**
   * @param parent the parent to search the dom tree from
   * @param el the element to search the parent dom tree
   *
   * @return does the element exist in any shadowRoot of the container
   */
  (parent: Element, el: Element): boolean;
}

/**
 * { @link ExistsIn }
 */
export default (parent: Element, el: Element): boolean => {
  if (!parent) {
    return false;
  }

  do {
    if (parent.contains(el)) {
      return true;
    }

    parent = (parent.shadowRoot as unknown) as Element;
  } while (parent);

  return false;
};
